"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNestedReplies = getNestedReplies;
exports.getTopicWithReplies = getTopicWithReplies;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _constants = require("./constants");

var _axios = _interopRequireDefault(require("axios"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function getTopicWithReplies(_x, _x2) {
  return _getTopicWithReplies.apply(this, arguments);
} // Nested replies always with oldestFirst order, so no need to pass sort option


function _getTopicWithReplies() {
  _getTopicWithReplies = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(publicTopicId, offset) {
    var _data$replies, _data$replies2;

    var pageSize,
        sort,
        _yield$axios$post,
        data,
        _args = arguments;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pageSize = _args.length > 2 && _args[2] !== undefined ? _args[2] : 10;
            sort = _args.length > 3 && _args[3] !== undefined ? _args[3] : _constants.DEFAULT_SORT;
            _context.next = 4;
            return _axios.default.post("/topic/".concat(publicTopicId, "/replies"), {
              offset: offset,
              pageSize: pageSize,
              sort: sort
            });

          case 4:
            _yield$axios$post = _context.sent;
            data = _yield$axios$post.data;
            return _context.abrupt("return", {
              result: ((_data$replies = data.replies) === null || _data$replies === void 0 ? void 0 : _data$replies.result) || [],
              metadata: (_data$replies2 = data.replies) === null || _data$replies2 === void 0 ? void 0 : _data$replies2.metadata,
              authors: data.authors || {}
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getTopicWithReplies.apply(this, arguments);
}

function getNestedReplies(_x3, _x4) {
  return _getNestedReplies.apply(this, arguments);
}

function _getNestedReplies() {
  _getNestedReplies = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(publicTopicId, params) {
    var _params$pageSize, _data$replies3, _data$replies4;

    var requestBody, _yield$axios$post2, data;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            requestBody = _objectSpread({
              offset: params.offset,
              pageSize: (_params$pageSize = params.pageSize) !== null && _params$pageSize !== void 0 ? _params$pageSize : _constants.NESTED_REPLIES_PAGE_SIZE,
              sort: _constants.SORT_KEYS.OLDEST_FIRST
            }, params.parentId && {
              parentId: params.parentId
            });
            _context2.next = 3;
            return _axios.default.post("/topic/".concat(publicTopicId, "/replies"), requestBody);

          case 3:
            _yield$axios$post2 = _context2.sent;
            data = _yield$axios$post2.data;
            return _context2.abrupt("return", {
              result: ((_data$replies3 = data.replies) === null || _data$replies3 === void 0 ? void 0 : _data$replies3.result) || [],
              metadata: (_data$replies4 = data.replies) === null || _data$replies4 === void 0 ? void 0 : _data$replies4.metadata,
              authors: data.authors || {}
            });

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getNestedReplies.apply(this, arguments);
}